import React, { Fragment } from 'react';
import { useRouteQuery } from 'src/common/helpers';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

import { NewProcessTemplate } from './components/new-process-template';
import { EditProcessTemplate } from './components/edit-process-template';

const ChangeProcessTemplate = () => {
  const query = useRouteQuery();
  const id: string = query.get('id') || '';
  const pageType: string = query.get('type') || '';

  return (
    <Fragment>
      {pageType === SETTINGS_PAGES.processTemplates && id === 'new' ? (
        <NewProcessTemplate />
      ) : (
        <EditProcessTemplate id={id} />
      )}
    </Fragment>
  );
};

export default ChangeProcessTemplate;
